<template>
  <v-container>
    <v-row v-if="progressKey">
      <v-col class="d-flex justify-center align-center">
        <v-progress-linear v-if="state" v-model="state.progress" color="light-blue" height="15" striped>
          {{ state.message }} {{ state.progress }}%
        </v-progress-linear>
      </v-col>
    </v-row>
    <!-- custom message -->
    <v-row v-if="message">
      <v-col class="d-flex justify-center">
        <v-progress-linear color="light-blue" height="15" striped>
          {{ message }}
        </v-progress-linear>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  props: {
    progressKey: null,
    message: null,
  },
  data() {
    return {
      state: null,
      timerId: null,
    };
  },
  watch: {
    progressKey(newVal) {
      if (newVal && !this.timerId) {
        this.init();
      }
    },
  },
  created() {
    if (this.progressKey) {
      this.init();
    }
  },
  methods: {
    init() {
      this.getProgress();
      this.timerId = setInterval(() => {
        this.getProgress();
      }, 5000);
    },
    getProgress() {
      this.axios
        .post(
          this.$model.wwwroot +
          "/procollege/index.php/core_procollege/helpers/ProgressHelper/getProgress",
          new URLSearchParams({
            key: this.progressKey,
          })
        )
        .then((response) => {
          if (response.data == false) {
            this.finish();
          } else {
            this.state = response.data;
          }
        })
        .catch((error) => {
          //this.finish();
        });
    },
    rmProgress() {
      this.axios
        .post(
          this.$model.wwwroot +
          "/procollege/index.php/core_procollege/helpers/ProgressHelper/deleteKey",
          new URLSearchParams({
            key: this.progressKey,
          })
        )
        .then((response) => {
          if (response.data == true) {
            this.finish();
          }
        })
        .catch((error) => {
          //this.finish();
        });
    },
    finish() {
      if (this.timerId) {
        clearInterval(this.timerId);
        this.timerId = null;
      }
      this.$emit("finish", this.progressKey);
    },
  },
};
</script>
